import api from './client';
import type {
  ApiResponse,
  CategoryNotificationPreference,
  NotificationLog,
  PaginationMeta,
} from '@/types';

export interface NotificationPreferenceOverview {
  category_id: string;
  category_name: string;
  upcoming_enabled: boolean;
  upcoming_days_before: number;
  overdue_enabled: boolean;
  overdue_reminder_interval: number | null;
}

export const notificationsApi = {
  listPreferences: () =>
    api.get<ApiResponse<NotificationPreferenceOverview[]>>('/notification-preferences/'),

  getCategoryPreference: (categoryId: string) =>
    api.get<ApiResponse<CategoryNotificationPreference>>(`/notification-preferences/${categoryId}/`),

  updateCategoryPreference: (categoryId: string, data: Partial<CategoryNotificationPreference>) =>
    api.put<ApiResponse<CategoryNotificationPreference>>(`/notification-preferences/${categoryId}/`, data),

  getLogs: (params?: Record<string, string | number>) =>
    api.get<ApiResponse<NotificationLog[]> & { meta?: PaginationMeta }>('/notification-log/', { params }),

  getFeed: (params?: Record<string, string | number>) =>
    api.get<ApiResponse<NotificationLog[]> & { meta?: PaginationMeta }>('/notifications/feed/', { params }),

  getUnreadCount: () =>
    api.get<ApiResponse<{ count: number }>>('/notifications/unread-count/'),

  markRead: (body: { ids?: string[]; all?: boolean }) =>
    api.post<ApiResponse<{ updated: number }>>('/notifications/mark-read/', body),
};
